import { Chapter, Reveal } from "@/components/Reveal";
import { GhostCTA } from "@/components/CTA";

const TOPICS = ["Speech", "Corsi", "Workshop", "Eventi per imprenditori", "Formazione aziendale"];

// Fotografie originali: card quadrate, object-position calibrato singolarmente per non tagliare i volti.
const PHOTOS = [
  { src: "/assets/evento-parco.jpg", pos: "center 39%", alt: "Mattia Cosimo Saracino durante un evento al Parco dei Principi", testid: "training-photo-1" },
  { src: "/assets/evento-abiti.jpg", pos: "center top", alt: "Mattia Cosimo Saracino durante un incontro di formazione", testid: "training-photo-2" },
  { src: "/assets/gruppo-evento.jpg", pos: "center center", alt: "Mattia Cosimo Saracino con imprenditori durante un evento", testid: "training-photo-3" },
  { src: "/assets/evento-attestato.jpg", pos: "center 68%", alt: "Mattia Cosimo Saracino con una cliente e l'attestato OSM Beauty, risultato +142,50%", testid: "training-photo-4" },
];

const Training = () => (
  <section id="formazione" data-testid="training-section" className="bg-fog py-28 text-ink lg:py-40">
    <div className="mx-auto max-w-[1440px] px-6 lg:px-12">
      <Chapter index="07" label="Formazione & Eventi" />
      <div className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <Reveal>
            <h2 className="font-display text-4xl font-extrabold leading-[1.05] tracking-tighter sm:text-5xl">
              Condividere conoscenza per generare cambiamento.
            </h2>
          </Reveal>
        </div>
        <div className="flex flex-col justify-end lg:col-span-5">
          <Reveal delay={0.1}>
            <div className="flex flex-wrap gap-3">
              {TOPICS.map((t) => (
                <span
                  key={t}
                  className="border border-ink/15 px-4 py-2 font-mono text-[10px] uppercase tracking-[0.22em] text-ink/60"
                >
                  {t}
                </span>
              ))}
            </div>
          </Reveal>
        </div>
      </div>

      <div className="mt-16 grid grid-cols-2 gap-4 lg:grid-cols-4 lg:gap-5" data-testid="training-gallery">
        {PHOTOS.map((p, i) => (
          <Reveal key={p.src} delay={i * 0.08}>
            <div className="group aspect-square overflow-hidden border border-ink/10">
              <img
                src={p.src}
                alt={p.alt}
                loading="lazy"
                data-testid={p.testid}
                style={{ objectPosition: p.pos }}
                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
              />
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.15} className="mt-14">
        <GhostCTA to="/eventi" testid="training-cta">
          Scopri eventi e formazione
        </GhostCTA>
      </Reveal>
    </div>
  </section>
);

export default Training;
